export enum InsightTitles {
  ADD_INCIDENT = 'New Incident',
  DETAIL_INCIDENT = 'Incident Details',
  EDIT_INCIDENT = 'Update Incident',
}

export enum InsightMode {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
  RESUME = 'resume',
  ADD_INCIDENT = 'addIncident',
  DETAIL_INCIDENT = 'incidentDetails',
  EDIT_INCIDENT = 'updateIncident',
  ADD_BEHAVIOR = 'addBehavior',
  EDIT_BEHAVIOR = 'updateBehavior',
  VIEW_BEHAVIOR = 'behaviorDetails',
  PRINT_CASE = 'printCase',
  CREATE_REPORT = 'createReport',
  EDIT_REPORT = 'editReport',
}

export enum BehaviourFunction {
  ESCAPE_AVOIDANCE = 'Escape/Avoidance',
  GAINING_ATTENTION = 'Gaining Attention',
  TANGIBLE = 'Tangible',
  SENSORY = 'Sensory',
  OTHER = 'Other/Unknown',
}
export enum AttachmentMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  VIEW = 'VIEW',
}

export enum BehaviorStatus {
  ACTIVE = 1,
  INACTIVE = 2,
}

export enum BehaviorFrequency {
  'Constantly' = 'It occurs almost always (every minute)',
  'Hourly' = 'It usually occurs at least once and possibly several times an hour',
  'Daily' = 'It usually occurs at least once and possibly several times a day',
  'Weekly' = 'It usually occurs at least once and possibly several times a week',
  'Monthly' = 'It usually occurs at least once and possibly several times a month',
}
export enum CustomQuestionReportType {
  BIP = 83,
  Details = 84,
  Both = 85,
}
